import { render, staticRenderFns } from "./English.vue?vue&type=template&id=4ec8dd05&"
import script from "./English.vue?vue&type=script&lang=js&"
export * from "./English.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports